import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";
import LargeItemStatus from "../../../../../../common/components/large_item_status";


type Props = {
  onActionEditar: (Tipo: "Corretiva" | "Preventivas", Id: number | null, openState: boolean) => void,
  onActionDeletar: (Id: number | null, openState: boolean) => void,
  onActionExportar: (Id: number) => void,
};

export const GenerateQualidadeAcoesMelhoriasColumns = ({
  onActionEditar,
  onActionDeletar,
  onActionExportar
}: Props): GridColDef[] => {


  //#region  Tipo
   const computeItemTipoTitle = (tipo: boolean) => {
    switch (tipo) {
      case false:
        return "Fechada";
      case true:
        return "Aberta";
      default:
        return "?";
    }
  };
  const computeItemTipoColor = (tipo: boolean) => {
    switch (tipo) {
      case false:
        return "green";
      default:
        return "blue";
    }
  };

  //#endregion

  return [
    {
      field: "AcaoAberta",
      filterable: false,
      headerName: "Tipo",
      flex: 1,
      maxWidth: 100,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeItemTipoTitle(params.value)}
            color={computeItemTipoColor(params.value)}
            description=""/>
        </div>
      )
    },
    {
      field: "Numero",
      filterable: false,
      headerName: "Nº",
      flex: 1,
      maxWidth: 70,
      sortable: false,
      renderCell: (params) => {
        return (<div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "Data",
      filterable: false,
      headerName: "Data",
      flex: 1,
      maxWidth: 100,
      sortable: false,
       renderCell: (params) => {
        return (<span className="w-full h-full flex justify-center items-center text-center text-xs py-2">{params.value && dayjs(params.value).format("DD/MM/YYYY")}</span>);
      },
    },
    {
      field: "Evento",
      filterable: false,
      headerName: "Evento",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "DescricaoSetor",
      filterable: false,
      headerName: "Setor",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
       return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "Assunto",
      filterable: false,
      headerName: "Assunto",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
     {
      field: "IdentificadoPor",
      filterable: false,
      headerName: "Identificado Por",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
       return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "Exportar",
      filterable: false,
      headerName: "Exportar",
      sortable: false,
      valueGetter: (_, row) => {
        return row["IdAcaoQualidade"] as number;
      },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onActionExportar(value);
                } else {
                  onActionExportar(value);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".2rem solid #45b6af",
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
              }}
              >
              Exportar
            </Button>
          </div>
        );
      },
    },
    {
    field: 'IdAcaoQualidade',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    minWidth: 150,

    renderCell: (params) => {
      return (
        <div className="flex items-center justify-center w-full h-full gap-1">
          
          <IconButton onClick={() => onActionEditar("Preventivas",params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
          </IconButton>
          
          <IconButton onClick={() => onActionDeletar(params.value, true)} >
            <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
          </IconButton>

        </div>
      );
    }
    },
  ];
}